const flaticonRefs = [
    {
        href: "https://www.flaticon.com/free-icons/brain",
        title: "brain icons",
        text: "Brain icons created by anilofex - Flaticon"
    },
    {
        href: "https://www.flaticon.com/free-icons/data-science",
        title: "data science icons",
        text: "Data science icons created by Eucalyp - Flaticon"
    },

    {
        href: "https://www.flaticon.com/free-icons/data-analytics",
        title: "data analytics icons",
        text: "Data analytics icons created by Triangle Squad - Flaticon"
    },
    {
        href: "https://www.flaticon.com/free-icons/integrated-development-environment",
        title: "integrated development environment icons",
        text: "Integrated development environment icons created by Dewi Sari - Flaticon"
    },
    {
        href: "https://icons8.com/icon/JHsm5oZeWqae/sun",
        title: "",
        text: "Sun icon by Icons8"
    },
    {
        href: "https://icons8.com/icon/HpcvnWPxS15j/moon-symbol",
        title: "",
        text: "Moon Symbol icon by Icons8"
    },
    {
        href: "https://www.freepik.com/free-vector/gradient-website-hosting-illustration_22112055.htm#query=database&position=26&from_view=search&track=sph",
        title: "",
        text: "GeDa project image by Freepik"
    }
]

export default flaticonRefs